import * as service from './service'
import { queryRecommendWords } from './service'
export default {
  namespace: 'recommendMessengerHome',
  state: {
    headDatas: {
      broadcastList: [],
      activityContent: {},
      countInfo: { rankList: [], rankListIsShow: false },
      cityId: '',
      cityName: ''
    }
  },
  effects: {
    * inviteList ({ payload }, { call, put }) {
      const res = yield call(service.inviteList, payload)
      return res.data
    },
    * invite ({ payload }, { call, put }) {
      const res = yield call(service.invite, payload)
      return res.data
    },
    * contact ({ payload }, { call, put }) {
      const res = yield call(service.contact, payload)
      return res.data
    },
    * confirmContact ({ payload }, { call, put }) {
      const res = yield call(service.confirmContact, payload)
      return res.data
    },
    * headData ({ payload }, { call, put }) {
      const res = yield call(service.headData, payload)
      yield put({
        type: 'save',
        payload: {
          headDatas: res.data.data
        }
      })
    },
    * queryRecommendWords ({ payload }, { call, put }) {
      const res = yield call(service.queryRecommendWords, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
